/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

import React, { Suspense, useContext, useEffect, useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import ErrorMessage from '../../components/ErrorMessage'
import Loader from '../../components/Loader'
import { MessageHandlerContext } from '../../context/MessageHandlerContextProvider'
import { RoutesConstant } from '../../util/constants'
import LottoBaseHome from '../views/LottoBaseHome'
import LotteriesCollection from '../views/LotteriesCollection'
import Register from '../views/Register'
const LotteryBaseLayout = () => {
  const { globalLoader, globalMessage, setGlobalMessage, themeState } = useContext(MessageHandlerContext)
  const [alertToggle, setAlertToggle] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setAlertToggle(!alertToggle)
      globalMessage && setGlobalMessage(null)
    }, 4000)
  }, [globalMessage])

  const loading = () => {
    return <Loader />
  }

  return (
    <div className="theme-layout-new">
      <section id="contentArea" className={`content ${themeState}`}>
        <div className={`main_content ${themeState}`}>
          {alertToggle && globalMessage && (
            <ErrorMessage message={globalMessage} />
          )}
          {globalLoader && <Loader />}
          <Suspense fallback={loading()}>
            <Switch>
              <Route
                path={RoutesConstant.BUY_SPECIFIC_ROUTE}
                exact={true}
                render={(props) => <LottoBaseHome {...props} />}
              />
              <Route
                path={RoutesConstant.LOTTO_COLLCECTION_ROUTE}
                exact={true}
                render={(props) => <LotteriesCollection {...props} />}
              />
              <Route
                path={RoutesConstant.REGISTER_ROUTE}
                exact={true}
                render={(props) => <Register {...props} />}
              />
            </Switch>
          </Suspense>
        </div>
      </section>
    </div>
  )
}

export default LotteryBaseLayout
